<p-tabView>

    <p-tabPanel header="Datos">
        <div class="p-grid">
            <div class="p-col-12 p-field">
                <label for="position">Orden</label>
                <input name="position" type="number" pInputText [(ngModel)]="entityField.position" />
            </div>
            <div class="p-col-12 p-field">
                <label for="name">Nombre</label>
                <input name="name" type="text" pInputText [(ngModel)]="entityField.name"
                    [disabled]="entityField.is_base_field" />
            </div>
            <div class="p-col-12 p-field">
                <label for="description">Descripción</label><br>
                <textarea name="description" pInputTextarea [(ngModel)]="entityField.description"
                    style="width: 100%; resize: none;"></textarea>
            </div>
            <div class="p-col-6 p-field">
                <label for="data_type">Tipo de dato</label>
                <p-dropdown appendTo="body" [options]="data_types" [(ngModel)]="selected_data_type" optionLabel="name"
                    optionValue="value" [disabled]="entityField.is_base_field" [showClear]="true"
                    (onChange)="updateControlType()"></p-dropdown>
            </div>
            <div class="p-col-6 p-field"
                *ngIf="entityField.data_type != 'list' && entityField.data_type != 'list_multiple' && entityField.data_type != 'date' && entityField.data_type != 'boolean'">
                <label for="default_value">Valor por defecto</label>
                <input name="default_value" type="text" pInputText [(ngModel)]="entityField.default_value" />
            </div>
            <div class="p-col-6 p-field" *ngIf="entityField.data_type == 'date'">
                <label for="default_value">Valor por defecto</label>
                <p-calendar dateFormat="dd/mm/yy" hourFormat="24" [showIcon]="true" [showTime]="true"  [touchUI]="true"
                    name="default_value" [(ngModel)]="entityField.default_value" appendTo="body" [stepMinute]="15">
                </p-calendar>
            </div>
            <div class="p-col-6 p-field" *ngIf="entityField.data_type == 'boolean'">
                <label for="default_value">Valor por defecto</label>
                <p-checkbox name="default_value" [(ngModel)]="entityField.default_value" binary="true"></p-checkbox>
            </div>
            <!--Tabla -->
            <div class="p-col-12" *ngIf="entityField.data_type == 'list' || entityField.data_type == 'list_multiple'">
                <p-card>
                    <ng-template pTemplate="header">
                        <div class="p-card-title">
                            Elementos de la lista
                            <div class="p-card-title-actions">
                                <a (click)="exportExcel()">
                                    <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>Descargar excel
                                </a>
                                <a (click)="addItemMasive()">
                                    <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon>Añadir masivo
                                </a>
                                <a (click)="addItem()">
                                    <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon>Añadir item
                                </a>
                            </div>
                        </div>
                    </ng-template>
                    <div class="p-grid">
                        <!--div class="p-col p-field">
                        <label for="code">Código</label>
                        <input name="code" type="text" pInputText [(ngModel)]="code" />
                    </div>
                    <div class="p-col p-field">
                        <label for="text">Texto</label>
                        <input name="text" type="text" pInputText [(ngModel)]="text" />
                    </div-->
                        <p-table #grid [value]="entityField.configuration?.options?.items">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Código</th>
                                    <th>Texto</th>
                                    <th width="70"></th>
                                    <th width="70"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item>
                                <tr>
                                    <td>{{item.code}}</td>
                                    <td>{{item.text}}</td>
                                    <td><a (click)="addItem(item)"><fa-icon [icon]="['far', 'edit']" class=""></fa-icon></a></td>
                                    <td><a (click)="deleteItem(item)"><fa-icon [icon]="['far', 'trash-alt']" class="color-danger"></fa-icon></a></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-card>
            </div>
            <div class="p-col-2 p-field">
                <label for="is_disabled">Desactivado</label>
                <p-checkbox name="is_disabled" [(ngModel)]="entityField.is_disabled" [binary]="true"></p-checkbox>
            </div>
            <div class="p-col-2 p-field">
                <label for="require_roles">Requiere roles</label>
                <p-checkbox name="require_roles" [(ngModel)]="require_roles" [binary]="true"></p-checkbox>
            </div>
            <div class="p-col-12" *ngIf="require_roles">
                <p-card>
                    <ng-template pTemplate="header">
                        <div class="p-card-title">
                            Roles
                        </div>
                    </ng-template>
                    <div class="p-grid">
                        <div class="p-col-4" *ngFor="let role of roles">
                            <p-checkbox name="selected_roles" [(ngModel)]="selectedRoles" value="{{role.id}}">
                            </p-checkbox> {{role.name}}
                        </div>
                    </div>
                </p-card>
            </div>
          <p-message *ngIf="entityField.unmodifiable" severity="info" text="Recuerde, este campo no puede ser MODIFICABLE así que sólo se visualizará en modo lectura."></p-message>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Configuración">
        <form #formDetails="ngForm">
            <p-card header="Detalles">
                <div class="p-grid">
                    <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="modelMonaco"
                        [ngModelOptions]="{standalone: true}" (init)="editorInit($event)"
                        (ngModelChange)="onMonacoChange($event)" style="height: 500px; width: 100%;">
                    </ngx-monaco-editor>
                </div>
            </p-card>

        </form>

    </p-tabPanel>
</p-tabView>
<div class="p-col-12 p-d-flex">
    <p-button label="Borrar" *ngIf="entityField.id > 0 && !entityField.is_base_field" icon="pi pi-trash"
        styleClass="p-button-danger" (click)="delete()"></p-button>
    <div class="flex-grow-1"></div>
    <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text" (click)="cancel()">
    </p-button>
    <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save(true)"></p-button>
</div>
